import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Divider,
  Button,
  TableBody,
} from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import axios from "axios";
import { useParams } from "react-router-dom";
import baseURL from "../../config";
import WalletForm from "./walletform.jsx";
import dayjs from "dayjs";
import RefundForm from "./RefundForm.jsx"; 

const Wallet = () => {
  const { id } = useParams();
  const [walletBalance, setWalletBalance] = useState(null);
  const [totals, setTotals] = useState({ topUp: 0, subscription: 0 });
  const [showRefundForm, setShowRefundForm] = useState(false);

  const fetchWalletBalance = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/wallet/getWalletBalance/${id}`);
      const data = response.data;

      const topUp = data.transactions
        ?.filter((tx) => tx.type === "top-up")
        .reduce((sum, tx) => sum + tx.amount, 0);

      const subscription = data.transactions
        ?.filter((tx) => tx.type === "subscription")
        .reduce((sum, tx) => sum + tx.amount, 0);

      setWalletBalance(data);
      setTotals({ topUp, subscription });
    } catch (err) {
      console.error("Error fetching wallet balance:", err);
    }
  };

  useEffect(() => {
    fetchWalletBalance();
  }, [id]);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom color="#C30B12" fontWeight="bold">
        Wallet
      </Typography>

      <Grid container spacing={3}>
        {/* Wallet Form */}
        <Grid item xs={12} md={6}>
          <WalletForm />
        </Grid>

        {/* Wallet Stats */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card sx={{ p: 2, borderLeft: "6px solid #C30B12" }}>
                <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <AccountBalanceWalletIcon sx={{ fontSize: 40, color: "#C30B12" }} />
                  <Box>
                    <Typography variant="h6">Current Balance</Typography>
                    <Typography variant="h4" fontWeight="bold">
                      $ {walletBalance?.balance?.toFixed(2) ?? "0.00"}
                    </Typography>
                   <Button
  variant="outlined"
  color="error"
  sx={{ mt: 1 }}
  onClick={() => setShowRefundForm((prev) => !prev)}
>
  {showRefundForm ? "Close Refund" : "Refund"}
</Button>

{showRefundForm && (
  <Box mt={2}>
    <RefundForm onRefundSuccess={fetchWalletBalance} />
  </Box>
)}

                  </Box>
                </CardContent>
              </Card>
              <Divider sx={{ my: 2 }} />

            </Grid>

            <Grid item xs={6}>
              <Card sx={{ p: 2, backgroundColor: "#e0f8f1" }}>
                <Typography variant="subtitle1">Total Top-Ups</Typography>
                <Typography variant="h6" fontWeight="bold" color="#00C875">
                  $ {totals.topUp.toFixed(2)}
                </Typography>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card sx={{ p: 2, backgroundColor: "#fdecea" }}>
                <Typography variant="subtitle1">Total Subscriptions</Typography>
                <Typography variant="h6" fontWeight="bold" color="#ff3b30">
                  $ {totals.subscription.toFixed(2)}
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>

        {/* Transactions Table */}
        <Grid item xs={12}>
          <Paper elevation={6} sx={{ borderRadius: 4, overflow: "hidden" }}>
            <Box
              sx={{
                background: "linear-gradient(to right, #C30B12, #f44336)",
                color: "#fff",
                px: 3,
                py: 2,
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                💳 Wallet Transactions
              </Typography>
            </Box>

            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#fafafa" }}>
                  <TableCell>📅 Date</TableCell>
                  <TableCell>📌 Type</TableCell>
                  <TableCell>💰 Amount</TableCell>
                  <TableCell>💱 Currency</TableCell>
                  <TableCell>📝 Note</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {walletBalance?.transactions?.length > 0 ? (
                  walletBalance.transactions.map((tx) => (
                    <TableRow key={tx._id}>
                      <TableCell>{dayjs(tx.date).format("DD MMM YYYY, hh:mm A")}</TableCell>
                      <TableCell>
                        <Typography
                          sx={{
                            px: 1.5,
                            py: 0.3,
                            display: "inline-block",
                            borderRadius: "999px",
                            backgroundColor:
                              tx.type === "top-up" ? "rgba(0, 200, 117, 0.1)" : "rgba(255, 99, 71, 0.1)",
                            color: tx.type === "top-up" ? "#00C875" : "#ff3b30",
                            fontWeight: 500,
                          }}
                        >
                          {tx.type === "top-up" ? "⬆ Top-up" : "🔁 Subscription"}
                        </Typography>
                      </TableCell>
                      <TableCell>$ {tx.amount.toFixed(2)}</TableCell>
                      <TableCell>{tx.currency}</TableCell>
                      <TableCell>{tx.note}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                      <Typography variant="body1" color="text.secondary">
                        No transactions found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Wallet;
